<template>
  <v-overlay
    :value="!!loading"
    class="text-center"
    :absolute="absolute"
  >
    <v-progress-circular
      indeterminate
      size="64"
    />
    <div
      v-if="$_.isString(loading)"
      class="mt-5 text-h2"
    >
      {{ loading }}
    </div>
  </v-overlay>
</template>
<script>
  export default {
    props: {
      loading: {
        type: [Boolean, String],
        default: () => false,
      },
      absolute: {
        type: Boolean,
        default: () => false,
      },
    },
  }
</script>
